import IMG1 from '../../../assets/img/certificates/certificates14001.png';
import IMG2 from '../../../assets/img/certificates/RINA.jpg';
import IMG3 from '../../../assets/img/certificates/certificates45001.png';
import IMG4 from '../../../assets/img/certificates/SOA_rilascio.jpg';
import IMG5 from '../../../assets/img/certificates/politica_qualita.jpg';

import IS09001 from '../../../assets/document/9001_2015_rev_02_2026.pdf';
import IS014001 from '../../../assets/document/14001_2015_rev_02_2026.pdf';
import IS045001 from '../../../assets/document/45001_2018_rev_02_2026.pdf';
import soa2025 from '../../../assets/certificates/34854_FINCANTIERI_SI_SPA.pdf';
import unipdr125 from '../../../assets/document/UNIPDR_125.pdf';
import ax from '../../../assets/certificates/ISO 37001 2025_IT345302   - FINCANTIERI SI S.P.A ita.pdf';
import az from '../../../assets/certificates/ISO 37001 2025_IT345302   - FINCANTIERI SI S.P.A ing.pdf';
import sa from '../../../assets/certificates/SI-PY-QAS_Politica Qualità Ambiente Sicurezza FCSI_Rev. 06 del 07-10-2026.pdf';

const getTitleLang = (title = '') => {
  if (/_EN\b/i.test(title)) return 'en';
  if (/_IT\b/i.test(title)) return 'it';
  return null;
};
export const getNameCertificates = (locale = 'it') => {
  const lang = (locale || 'it').split('-')[0];

  const list = [
    {
      image: IMG1,
      title: 'UNI EN ISO 37001:2025_EN',
      url: az,
    },
    {
      image: IMG1,
      title: 'UNI EN ISO 37001:2025_IT',
      url: ax,
    },
    {
      image: IMG1,
      title:
        lang === 'en'
          ? 'POLICY FOR QUALITY, ENVIRONMENT, OCCUPATIONAL HEALTH AND SAFETY, PREVENTION OF CORRUPTION, AND SOCIAL RESPONSIBILITY'
          : 'POLITICA PER LA QUALITÀ, L’AMBIENTE, LA SALUTE E SICUREZZA SUL LAVORO, LA PREVENZIONE DELLA CORRUZIONE E LA RESPONSABILITÀ SOCIALE',
      url: sa,
    },
    {
      image: IMG1,
      title: 'UNI EN ISO 14001:2015',
      url: IS014001,
    },
    {
      image: IMG2,
      title: 'UNI EN ISO 9001:2015',
      url: IS09001,
    },
    {
      image: IMG3,
      title: 'UNI EN ISO 45001:2018',
      url: IS045001,
    },
    {
      image: IMG4,
      title: 'SOA OG9 CLASS. V – OG10 CLASS. VIII – OG11 CLASS. VIII',
      url: soa2025,
    },
    {
      image: IMG5,
      title: 'UNIPDR 125',
      url: unipdr125,
    },
  ];
  return list.filter((item) => {
    const titleLang = getTitleLang(item.title);
    return titleLang === null || titleLang === lang;
  });
};
